export class Plugin {
    constructor() {
        this.type = 'backend';
        this.resolvers = {};
    }

    init(services, backendOptions, i18nextOptions) {
        this.services = services;
        this.backendOptions = backendOptions;
        this.i18nextOptions = i18nextOptions;
    }

    registerResolver(namespace, resolver) {
        this.resolvers[namespace] = resolver;
    }

    async read(language, namespace, callback) {
        try {
            const resolver = this.resolvers[namespace];

            if (!resolver) {
                return callback(new Error(`Localization resolver for namespace "${namespace}" not registered`), null);
            }

            const localization = await resolver(language);

            callback(null, localization.default || localization);
        } catch (err) {
            callback(err, null);
        }
    }

    create(languages, namespace, key, fallbackValue) {
        // eslint-disable-next-line no-console
        console.log(`languages=${languages}, namespace=${namespace}, key=${key}, fallbackValue=${fallbackValue}`);
    }
}
